module.exports = __webpack_public_path__ + "static/media/r12.5cdb27ee.jpg";